import { ENV } from 'constants/index';
import fetcher from '@utils/fetcher';
import { v4 as uuidv4 } from 'uuid';
import { parseCookies, setCookie, destroyCookie } from 'nookies';

export const API_PREFIX = {
  v1: '/api/v1',
  v2: '/api/v2',
};

const removeCookiesAuth = () => {
  destroyCookie(null, 'token');
  destroyCookie(null, 'role');
  destroyCookie(null, 'isLogedIn');
};

const setUserRequestId = () => {
  const cookies = parseCookies();
  if (!cookies.requestId) {
    setCookie(null, 'requestId', uuidv4(), {
      maxAge: 1 * 24 * 60 * 60,
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'strict',
    });
  }
};

setUserRequestId();

export const apiRequest = ({ prefix = API_PREFIX.v1, url = null }) => {
  const generateApiUrl = () => {
    const baseURL = ENV.BASE_API_URL;
    return `${baseURL}${prefix}`;
  };

  const baseURL = url ?? generateApiUrl();

  return fetcher({
    baseURL,
    loginApiPath: '/login',
    onLogout: () => {
      removeCookiesAuth();
      // handle if token is expired
      // window.location.href = "/login";
    },
  });
};

const request = fetcher({
  baseURL: `${ENV.BASE_API_URL}${API_PREFIX.v1}`,
  loginApiPath: '/login',
  onLogout: () => {
    removeCookiesAuth();
    // handle if token is expired
    // window.location.href = "/login";
  },
});

export default request;
